import React from 'react';
import Label from 'components/form/Label/Label';
import { ReactComponent as Logo } from 'style/_assets/migrate-user-banner.svg';
import { ReactComponent as ChevronRight } from 'style/_assets/icons/chevron-right.svg';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import './VerifyAccountBanner.scss';

const getVerificationMessage = (
  emailConfirmed,
  contactPhoneNumberConfirmed,
) => {
  if (!emailConfirmed && !contactPhoneNumberConfirmed)
    return 'Please verify your email and phone number';
  if (!emailConfirmed) return 'Please verify your email';
  if (!contactPhoneNumberConfirmed) return 'Please verify your phone number';
  return null;
};

export const VerifyAccountBanner = ({
  emailConfirmed,
  contactPhoneNumberConfirmed,
  onClick,
}) => {
  const message = getVerificationMessage(
    emailConfirmed,
    contactPhoneNumberConfirmed,
  );

  return (
    <FlexContainer
      className="verify-account-banner borderRadius8 system_neutral_n000 gap-12 pad8 margTB20 margLR16 m-margLR8"
      alignItemsCenter
      justifyBetween
      onClick={onClick}
    >
      <FlexContainer className="logo-container">
        <Logo width="100%" height="100%" role="definition" />
      </FlexContainer>

      <Label className="text-15 m-text-13">
        <span className="fontLatoNormal700">{message}</span> so you can get the
        most out of your experience and receive the most critical notifications
      </Label>

      <FlexContainer className="chevron-container">
        <ChevronRight width="100%" height="100%" />
      </FlexContainer>
    </FlexContainer>
  );
};
